/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Planshare_CopiedInputs */

const en_us2_planshare_copied = /** @type {(inputs: Planshare_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Code copied`)
};

const pt_br2_planshare_copied = /** @type {(inputs: Planshare_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Código copiado`)
};

const pt_pt2_planshare_copied = /** @type {(inputs: Planshare_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Código copiado`)
};

/** @type {(inputs: Planshare_CopiedInputs) => LocalizedString} */
const es_419_planshare_copied = en_us2_planshare_copied;

/** @type {(inputs: Planshare_CopiedInputs) => LocalizedString} */
const fr_fr2_planshare_copied = en_us2_planshare_copied;

/** @type {(inputs: Planshare_CopiedInputs) => LocalizedString} */
const de_de2_planshare_copied = en_us2_planshare_copied;

/** @type {(inputs: Planshare_CopiedInputs) => LocalizedString} */
const it_it2_planshare_copied = en_us2_planshare_copied;

/**
* | output |
* | --- |
* | "Code copied" |
*
* @param {Planshare_CopiedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const planshare_copied = /** @type {((inputs?: Planshare_CopiedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Planshare_CopiedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_planshare_copied(inputs)
	if (locale === "es-419") return es_419_planshare_copied(inputs)
	if (locale === "pt-PT") return pt_pt2_planshare_copied(inputs)
	if (locale === "fr-FR") return fr_fr2_planshare_copied(inputs)
	if (locale === "de-DE") return de_de2_planshare_copied(inputs)
	if (locale === "it-IT") return it_it2_planshare_copied(inputs)
	return en_us2_planshare_copied(inputs)
});
export { planshare_copied as "planshare.copied" }